import { useMutation } from '@apollo/client';
import { CREATE_PICKUP_ROUTE } from '../graphql/mutations/createPickupRoute';
import { CreatePickupRouteInput, CreatePickupRouteResponse } from '../graphql/types/PickupRouteTypes';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

export const useCreatePickupRoute = () => {
  const { t } = useTranslation();
  const [createPickupRoute, { loading, error }] = useMutation<
    CreatePickupRouteResponse,
    { input: CreatePickupRouteInput }
  >(CREATE_PICKUP_ROUTE);

  const createRoute = async (input: CreatePickupRouteInput) => {
    try {
      const response = await createPickupRoute({
        variables: { input },
        // 可以在这里添加其他选项，比如refetchQueries等
      });
      
      if (response.data?.createPickupRoute) {
        return response.data.createPickupRoute;
      } else {
        throw new Error(t('pickup.pickupTask.pageDetails.messages.failedToCreateRoute') || '');
      }
    } catch (err: any) {
      console.error('Error creating pickup route:', err);
      const errorMessage = err.message || t('pickup.pickupTask.pageDetails.messages.failedToCreateRoute') || '';
      message.error(errorMessage);
      throw err;
    }
  };

  return {
    createRoute,
    loading,
    error,
  };
};
